import styled from 'styled-components';
import { spacer12 } from '@spotify-internal/encore-foundation';
export default styled.ul.attrs({
  role: 'tabslist'
}).withConfig({
  displayName: "NavBarList",
  componentId: "sc-1otk78t-0"
})(["display:flex;margin-bottom:", ";padding-bottom:0;"], spacer12);